import styled from 'styled-components';

export const Container = styled.header`
  width: 100vw;
  height: 75px;

  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  position: relative;

  padding: 2rem 6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      margin-right: 30px;
    }

    .CDLLogo {
      /* margin: 0 4px; */
      width: 160px;
    }
  }
`;

export const Selects = styled.div`
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  > p {
    font-size: 1.2rem;
    color: #0a78cb;
  }

  .select {
    margin-top: 14px;
    margin-left: 6px;
  }

  @media (max-width: 769px) {
    margin-left: 5px;

    > p {
      font-size: 1.2rem;
      color: #0a78cb;
    }

    .select {
      /* margin-top: 14px; */
      margin-left: 0;
    }
  }
  @media (max-width: 415px) {
    overflow-x: scroll;
    margin-left: 5px;
  }
`;

export const Perfil = styled.div`
  display: flex;
  align-items: center;
`;

export const FiltrosDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  p {
    margin-left: -20px;
    font-size: 1.2rem;
    color: #0a78cb;
  }
  input {
    margin-right: 30px;
    margin-left: 2px;

    width: 140px;
    /* height: 20px; */
    border-radius: 5px;
    border: none;
    padding: 8px;
    color: #666;

    &:focus {
      outline: none;
    }

    &:first-child {
      margin-right: 10px;
    }
  }

  button {
    border: 0;
    background: transparent;

    margin: 1rem;

    img {
      width: 30px;
      height: 30px;
    }
  }

  @media (max-width: 768px) {
    button {
      margin: 0;
    }
  }
  @media (max-width: 600px) {
    button {
      margin-left: 0;
    }
    p {
      margin-left: -30px;
      font-size: 0.7rem;
      color: #0a78cb;
    }
    input {
      margin-right: 30px;
      margin-left: 2px;

      width: 140px;
      height: 20px;
      border-radius: 5px;
      border: none;
      padding: 8px;
      color: #666;
    }
  }
`;
